import { useEffect, useState } from "react";
import Input, { InputProps } from "./Input";
import { makeValueOnSchema } from "./Utils";

export default function ObjectInput(props: InputProps) {

    const [value, setValue] = useState<any>(props.value ? props.value : makeValueOnSchema(props.content));

    const fields = [...(props.content.required as string[])];

    Object.keys(props.content.properties).forEach(field => {
        if(!fields.find(
            function(str: string) {
                return str === field;
            }
        )) {
            fields.push(field);
        }
    })

    useEffect(() => {
        props.onChange(value);
    }, [value])

    return <div>
        {props.hasParent && !props.fromArray && <p>{props.content.title}</p> } 
        <div style={(props.hasParent ? {border: "1px solid black", padding: "10px"} : {})}>
            {fields.map(field => {
                return <Input key={field} content={props.content.properties[field]} hasParent required={props.required && props.content.required.find(
                    function(str: string) {
                        return str === field;
                    }
                )} onChange={(val) => {
                    setValue(((o: any) => ({...o, [field]: val,})))
                }} value={(props.value && value[field]) ? value[field] : undefined}></Input>
            })}   
        </div>
             
    </div>
}